import React from 'react';

function CheckupServiceLegal() {
    return (
        <React.Fragment>
            <h6>Ειδοποίηση Ιδιωτικότητας - Ενεργειακού Ελέγχου </h6>
            <p>
                Τα προσωπικά σας δεδομένα, που μας παρέχετε με την υποβολή αιτήματος για την παροχή της ενεργειακής
                υπηρεσίας Ενεργειακού Ελέγχου (Energy Checkup), συλλέγονται και επεξεργάζονται από την Εταιρεία
                Προμήθειας Αερίου Θεσσαλονίκης Θεσσαλίας Α.Ε. (ΖeniΘ) που εδρεύει στη Θεσσαλονίκη, οδός 26ης Οκτωβρίου,
                με Α.Φ.Μ. 997998048, ΓΕΜΗ 141002104000 τηλ. επικοινωνίας 2311223099, που εκπροσωπείται νόμιμα, σύμφωνα
                με τον Γενικό Κανονισμό (ΕΕ) 2016/679 περί προστασίας δεδομένων προσωπικού χαρακτήρα.
            </p>
            <p>
                <b>Σκοπός της Επεξεργασίας</b>: Η ΖeniΘ (Υπεύθυνος Επεξεργασίας), επεξεργάζεται τα προσωπικά δεδομένα
                σας:
                ονοματεπώνυμο, διεύθυνση, αριθμό σταθερού τηλεφώνου ή αριθμό κινητού τηλέφωνο, ΑΦΜ, Δ.Ο.Υ, δεδομένα που
                αφορούν την εγκατάσταση θέρμανσης του ακινήτου για το οποίο έχετε συμβληθεί με τη ZeniΘ για την
                προμήθεια φυσικού αερίου ή/και ηλεκτρικής ενέργειας, τις ηλεκτρικές συσκευές που βρίσκονται στο ακίνητο
                αυτό, πληροφορίες που αφορούν στο φωτισμό του ακινήτου, το έτος κατασκευής του ακινήτου, την καθαρή
                επιφάνεια, το υψόμετρο της περιοχής στην θέση του ακινήτου, τον αριθμό ατόμων που διαμένουν στο ακίνητο,
                τις πρόσθετες επεμβάσεις θερμομόνωσης, των αριθμό των οριζόντιων & κατακόρυφων εξωτερικών επιφανειών του
                κτιρίου, ενημέρωση για προτάσεις ενεργειακής αναβάθμισης του ακινήτου, καθώς και τη διεύθυνση
                ηλεκτρονικού ταχυδρομείου (email), για τους ακόλουθους σκοπούς: α) διενέργεια ενεργειακού ελέγχου
                (Energy checkup) σε αυτοτελή κατοικία, β) εκδόσεως κωδικού ενεργειακής υπηρεσίας από την ZeniΘ για
                παροχή της υπηρεσίας, προκειμένου να δύναται να παράσχει την υπηρεσία Energy checkup, εφόσον ο ίδιος το
                επιλέξετε.
            </p>
            <p>
                Επίσης, εφόσον παράσχετε τη συγκατάθεσή σας, η ΖeniΘ θα μπορεί να χρησιμοποιεί τα δεδομένα σας
                προκειμένου να ενημερώνεστε με το τρόπο που θα επιλέξετε για τις υπηρεσίες και τα προϊόντα ZeniΘ.
            </p>
            <b>Αποδέκτες</b>
            <ul style={{listStyleType: "none"}}>
                <li>Α. Εξουσιοδοτημένο προσωπικό της ZeniΘ</li>
                <li>Β. Εξωτερικοί Συνεργάτες της ZeniΘ για την παροχή υπηρεσιών ΣΥΝΤΗΡΗΣΗΣ ΛΕΒΗΤΩΝ.</li>
                <li>Γ. Εξωτερικοί Συνεργάτες της ZeniΘ για την παροχή υπηρεσιών εξυπηρέτησης μέσω τηλεφωνικού
                    κέντρου.
                </li>
                <li>Δ. Οποιαδήπoτε αρμόδια εποπτική, δημόσια ή δικαστική αρχή, εφόσον αυτό επιβάλλεται από το
                    εκάστοτε ισχύον νομοθετικό πλαίσιο ή από δικαστική απόφαση.
                </li>
            </ul>
            <p>
                Τα Δικαιώματά σας: Ως υποκείμενο δεδομένων προσωπικού χαρακτήρα, έχετε ορισμένα δικαιώματα.
                Συγκεκριμένα, μπορείτε α) να έχετε ενημέρωση και να λαμβάνετε αντίγραφο των δεδομένων σας κατόπιν
                αιτήματος, β) να απαιτήσετε από την ZeniΘ να διορθώσει λανθασμένα ή ελλιπή δεδομένα, γ) να διαγράψει ή
                να σταματήσει την επεξεργασία των δεδομένων σας, για παράδειγμα όταν τα δεδομένα δεν είναι πλέον
                απαραίτητα για τους σκοπούς της επεξεργασίας, δ) να αντιταχθείτε στην επεξεργασία των δεδομένων σας,
                όπου η ZeniΘ βασίζεται σε έννομα συμφέροντά της ως νομικό υπόβαθρο για την επεξεργασία, ε) να ζητήσετε
                από την ΖeniΘ την φορητότητα των δεδομένων προσωπικού χαρακτήρα σας στ) να ανακαλέσετε τη συγκατάθεσή
                σας για την επεξεργασία ανά πάσα στιγμή και χωρίς κάποια οικονομική επιβάρυνση. Το δικαίωμα αυτό
                υφίσταται μόνο εάν η συναίνεση χρησιμοποιείται ως προϋπόθεση της επεξεργασίας].
            </p>
            <p>
                Σε περίπτωση άσκησης ενός εκ των ανωτέρω αναφερόμενων δικαιωμάτων σας, η ZeniΘ, θα λάβει κάθε
                δυνατό μέτρο για την ικανοποίηση του αιτήματος σας εντός ενός (1) μηνός από την λήψη αυτού,
                ενημερώνοντας σας γραπτώς για την ικανοποίηση του αιτήματος σας ή τους λόγους που εμποδίζουν την
                εκ μέρους σας άσκηση, ή και την ικανοποίηση ενός ή και περισσότερων εκ των ως άνω αναφερόμενων
                δικαιωμάτων σας σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων.
            </p>
            <p>
                <b>Διακράτηση</b>: Τα δεδομένα σας που αφορούν στην έκδοση κωδικού ενεργειακής υπηρεσίας ZeniΘ, καθώς
                και την
                παροχή της υπηρεσίας Ενεργειακού Ελέγχου (Energy check up), θα τηρούνται από την ZeniΘ για το χρόνο που
                παραμένει σε ισχύ η σύμβαση προμήθειας Φυσικού αερίου ή ηλεκτρικού ρεύματος, που έχετε συνάψει με την
                ZeniΘ, εκτός αν ανακαλέσετε τη συγκατάθεσή σας για την επεξεργασία μόνον των συγκεκριμένων δεδομένων που
                συνδέονται με τις ανωτέρω υπηρεσίες και υπό την επιφύλαξη ότι δεν θίγονται τα νόμιμα δικαιώματα και οι
                υποχρεώσειε της ZeniΘ για τη διακράτηση των δεδομένων αυτών από την ZeniΘ σύμφωνα με τα οριζόμενα στις
                διατάξεις του Κανονισμού και της εκάστοτε ισχύουσας κείμενης νομοθεσίας.
            </p>
            <p>
                Περαιτέρω, σας γνωρίζουμε ότι έχετε το δικαίωμα να προσφύγετε στην Αρχή Προστασίας Δεδομένων Προσωπικού
                Χαρακτήρα για ζητήματα που αφορούν την επεξεργασία προσωπικών σας δεδομένων. Για την αρμοδιότητα της
                Αρχής και τον τρόπο υποβολής καταγγελίας, μπορείτε να επισκεφθείτε την ιστοσελίδα της (www.dpa.gr → Τα
                δικαιώματά μου →Υποβολή καταγγελίας), όπου υπάρχουν αναλυτικές πληροφορίες.
            </p>
            <p>
                <b>Υπεύθυνος Προστασίας Δεδομένων</b>: Για την άσκηση των δικαιωμάτων σας, μπορείτε να απευθυνθείτε στον
                Υπεύθυνο Προστασίας Δεδομένων (DPO) της ZeniΘ, στο τηλέφωνο: 2311-223 000, καθώς και στο email:
                <a href={"mailto:dataprivacy@zenith.gr"}>dataprivacy@zenith.gr</a>
            </p>
            <p>
                Για περισσότερες πληροφορίες, παρακαλούμε διαβάστε την <b>Πολιτική Απορρήτου</b> της ΖeniΘ στον σύνδεσμο
                <a href={"https://www.zenith.gr/privacy/"}>https://www.zenith.gr/privacy/</a>
            </p>
            <p>
                <b>Συναινώ για την επεξεργασία των προσωπικών μου δεδομένων από την ZeniΘ με σκοπό την έκδοση κωδικού
                    ενεργειακής υπηρεσίας ZeniΘ, καθώς και την παροχή της υπηρεσίας Ενεργειακού Ελέγχου (Energy check
                    up).
                </b>
            </p>
            <p>
                Μπορείτε να ανακαλέστε την συγκατάθεσή σας οποτεδήποτε και χωρίς κόστος αποστέλλοντας email στην
                διεύθυνση <a href={"mailto:dataprivacy@zenith.gr"}>dataprivacy@zenith.gr</a>
            </p>
        </React.Fragment>
    )
}

function MaintenanceServiceLegal() {
    return (
        <React.Fragment>
            <h6>Ειδοποίηση Ιδιωτικότητας - ΣΥΝΤΗΡΗΣΗΣ ΛΕΒΗΤΩΝ</h6>
            <p>
                Τα προσωπικά σας δεδομένα, που μας παρέχετε με την υποβολή αιτήματος για την παροχή της ενεργειακής
                υπηρεσίας ΣΥΝΤΗΡΗΣΗΣ ΛΕΒΗΤΩΝ {"<"}50 kW, συλλέγονται και επεξεργάζονται από την Εταιρεία Προμήθειας
                Αερίου Θεσσαλονίκης - Θεσσαλίας Α.Ε. (ΖeniΘ) που εδρεύει στη Θεσσαλονίκη, οδός 26ης Οκτωβρίου, με Α.Φ.Μ.
                997998048, ΓΕΜΗ 141002104000 τηλ. επικοινωνίας 2311223099, που εκπροσωπείται νόμιμα, σύμφωνα με τον
                Γενικό Κανονισμό (ΕΕ) 2016/679 περί προστασίας δεδομένων προσωπικού χαρακτήρα.
            </p>
            <p>
                <b>Σκοπός της Επεξεργασίας</b>: Η ΖeniΘ (Υπεύθυνος Επεξεργασίας), επεξεργάζεται τα προσωπικά δεδομένα
                σας:
                ονοματεπώνυμο, διεύθυνση, αριθμό σταθερού τηλεφώνου ή αριθμό κινητού τηλέφωνο, ΑΦΜ, Δ.Ο.Υ, καθώς και τη
                διεύθυνση ηλεκτρονικού ταχυδρομείου (email), για τους ακόλουθους σκοπούς: α) παροχής ετήσιας προληπτικής
                συντήρησης λειτουργικών λεβήτων φυσικού αερίου (άνευ βλάβης), β) εκδόσεως κωδικού ενεργειακής υπηρεσίας
                από την ZeniΘ για παροχή της υπηρεσίας, προκειμένου να δύναται η ZeniΘ να παράσχει την υπηρεσία
                ΣΥΝΤΗΡΗΣΗΣ ΛΕΒΗΤΩΝ, εφόσον ο ίδιος το επιλέξετε.
            </p>
            <b>Αποδέκτες</b>
            <ul style={{listStyleType: "none"}}>
                <li>Α. Εξουσιοδοτημένο προσωπικό της ZeniΘ</li>
                <li>Β. Εξωτερικοί Συνεργάτες της ZeniΘ για την παροχή υπηρεσιών ΣΥΝΤΗΡΗΣΗΣ ΛΕΒΗΤΩΝ.</li>
                <li>Γ. Εξωτερικοί Συνεργάτες της ZeniΘ για την παροχή υπηρεσιών εξυπηρέτησης μέσω τηλεφωνικού
                    κέντρου.
                </li>
                <li>Δ. Οποιαδήπoτε αρμόδια εποπτική, δημόσια ή δικαστική αρχή, εφόσον αυτό επιβάλλεται από το
                    εκάστοτε ισχύον νομοθετικό πλαίσιο ή από δικαστική απόφαση.
                </li>
            </ul>
            <p>
                <b>Τα Δικαιώματά σας</b>: Ως υποκείμενο δεδομένων προσωπικού χαρακτήρα, έχετε ορισμένα δικαιώματα.
                Συγκεκριμένα, μπορείτε α) να έχετε ενημέρωση και να λαμβάνετε αντίγραφο των δεδομένων σας κατόπιν
                αιτήματος, β) να απαιτήσετε από την ZeniΘ να διορθώσει λανθασμένα ή ελλιπή δεδομένα, γ) να διαγράψει ή
                να σταματήσει την επεξεργασία των δεδομένων σας, για παράδειγμα όταν τα δεδομένα δεν είναι πλέον
                απαραίτητα για τους σκοπούς της επεξεργασίας, δ) να αντιταχθείτε στην επεξεργασία των δεδομένων σας,
                όπου η ZeniΘ βασίζεται σε έννομα συμφέροντά της ως νομικό υπόβαθρο για την επεξεργασία, ε) να ζητήσετε
                από την ΖeniΘ την φορητότητα των δεδομένων προσωπικού χαρακτήρα σας στ) να ανακαλέσετε τη συγκατάθεσή
                σας για την επεξεργασία ανά πάσα στιγμή και χωρίς κάποια οικονομική επιβάρυνση. [Το δικαίωμα αυτό
                υφίσταται μόνο εάν η συναίνεση χρησιμοποιείται ως προϋπόθεση της επεξεργασίας].
            </p>
            <p>
                Σε περίπτωση άσκησης ενός εκ των ανωτέρω αναφερόμενων δικαιωμάτων σας, η ZeniΘ, θα λάβει κάθε
                δυνατό μέτρο για την ικανοποίηση του αιτήματος σας εντός ενός (1) μηνός από την λήψη αυτού,
                ενημερώνοντας σας γραπτώς για την ικανοποίηση του αιτήματος σας ή τους λόγους που εμποδίζουν την
                εκ μέρους σας άσκηση, ή και την ικανοποίηση ενός ή και περισσότερων εκ των ως άνω αναφερόμενων
                δικαιωμάτων σας σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων
            </p>
            <p>
                <b>Διακράτηση</b>: Τα δεδομένα σας που αφορούν στην έκδοση κωδικού ενεργειακής υπηρεσίας ZeniΘ, καθώς
                και την
                παροχή της υπηρεσίας ΣΥΝΤΗΡΗΣΗΣ ΛΕΒΗΤΩΝ, θα τηρούνται από την ZeniΘ για το χρόνο που παραμένει σε ισχύ η
                σύμβαση προμήθειας Φυσικού αερίου ή ηλεκτρικού ρεύματος, που έχετε συνάψει με την ZeniΘ, εκτός αν
                ανακαλέσετε τη συγκατάθεσή σας για την επεξεργασία μόνον των συγκεκριμένων δεδομένων που συνδέονται με
                τις ανωτέρω υπηρεσίες και υπό την επιφύλαξη ότι δεν θίγονται τα νόμιμα δικαιώματα και οι υποχρεώσειε
                της ZeniΘ για τη διακράτηση των δεδομένων αυτών από την ZeniΘ σύμφωνα με τα οριζόμενα στις διατάξεις του
                Κανονισμού και της εκάστοτε ισχύουσας κείμενης νομοθεσίας
            </p>
            <p>
                Περαιτέρω, σας γνωρίζουμε ότι έχετε το δικαίωμα να προσφύγετε στην Αρχή Προστασίας Δεδομένων Προσωπικού
                Χαρακτήρα για ζητήματα που αφορούν την επεξεργασία προσωπικών σας δεδομένων. Για την αρμοδιότητα της
                Αρχής και τον τρόπο υποβολής καταγγελίας, μπορείτε να επισκεφθείτε την ιστοσελίδα της (www.dpa.gr → Τα
                δικαιώματά μου →Υποβολή καταγγελίας), όπου υπάρχουν αναλυτικές πληροφορίες.
            </p>
            <p>
                <b>Υπεύθυνος Προστασίας Δεδομένων</b>: Για την άσκηση των δικαιωμάτων σας, μπορείτε να απευθυνθείτε στον
                Υπεύθυνο Προστασίας Δεδομένων (DPO) της ZeniΘ, στο τηλέφωνο: 2311-223 000, καθώς και στο email:
                <a href={"mailto:dataprivacy@zenith.gr"}>dataprivacy@zenith.gr</a>
            </p>
            <p>
                Για περισσότερες πληροφορίες, παρακαλούμε διαβάστε την Πολιτική Απορρήτου της ΖeniΘ στον σύνδεσμο
                <a href={"https://www.zenith.gr/privacy/"}>https://www.zenith.gr/privacy/</a>
            </p>
            <p>
                <b>
                    Συναινώ για την επεξεργασία των προσωπικών μου δεδομένων από την ZeniΘ για την έκδοση κωδικού
                    ενεργειακής υπηρεσίας ZeniΘ, καθώς και την παροχή της υπηρεσίας ΣΥΝΤΗΡΗΣΗΣ ΛΕΒΗΤΩΝ.
                </b>
            </p>
            <p>
                Σας ενημερώνουμε ότι μπορείτε να ανακαλέστε την συγκατάθεσή σας οποτεδήποτε και χωρίς κόστος
                αποστέλλοντας email στην διεύθυνση <a href={"mailto:dataprivacy@zenith.gr"}> dataprivacy@zenith.gr</a>
            </p>
        </React.Fragment>
    )
}

function PeaServiceLegal() {
    return(
        <React.Fragment>
            <h6>Ειδοποίηση Ιδιωτικότητας - Πιστοποιητικού Ενεργειακής Απόδοσης (Π.Ε.Α.)</h6>
           <p>
               Τα προσωπικά σας δεδομένα, που μας παρέχετε με την υποβολή αιτήματος για την παροχή της ενεργειακής υπηρεσίας ΕΚΔΟΣΗΣ
               ΠΙΣΤΟΠΟΙΗΤΙΚΟΥ ΕΝΕΡΓΕΙΑΚΗΣ ΑΠΟΔΟΣΗΣ (Π.Ε.Α.), συλλέγονται και επεξεργάζονται από την Εταιρεία Προμήθειας Αερίου Θεσσαλονίκης - 
               Θεσσαλίας Α.Ε. (ΖeniΘ) που εδρεύει στη Θεσσαλονίκη, οδός 26ης Οκτωβρίου, με Α.Φ.Μ. 997998048, ΓΕΜΗ 141002104000 τηλ. επικοινωνίας
               2311223099, που εκπροσωπείται νόμιμα, σύμφωνα με τον Γενικό Κανονισμό (ΕΕ) 2016/679 περί προστασίας δεδομένων προσωπικού
               χαρακτήρα.
           </p>
            <p>
                <b>Σκοπός της Επεξεργασίας:</b> Η ΖeniΘ (Υπεύθυνος Επεξεργασίας), επεξεργάζεται τα προσωπικά δεδομένα σας: ονοματεπώνυμο, διεύθυνση,
                αριθμό σταθερού τηλεφώνου ή αριθμό κινητού τηλέφωνο, ΑΦΜ, Δ.Ο.Υ, τη διεύθυνση ηλεκτρονικού ταχυδρομείου (email) καθώς και
                οποιοδήποτε τεχνικό ή κτιριακό ή περιουσιακό δεδομένο είναι απαραίτητο για την παροχή της ενεργειακής υπηρεσίας ΕΚΔΟΣΗΣ
                ΠΙΣΤΟΠΟΙΗΤΙΚΟΥ ΕΝΕΡΓΕΙΑΚΗΣ ΑΠΟΔΟΣΗΣ (Π.Ε.Α.), για τους ακόλουθους σκοπούς: α) παροχής της ενεργειακής υπηρεσίας ΕΚΔΟΣΗΣ
                ΠΙΣΤΟΠΟΙΗΤΙΚΟΥ ΕΝΕΡΓΕΙΑΚΗΣ ΑΠΟΔΟΣΗΣ (Π.Ε.Α.), β) εκδόσεως κωδικού ενεργειακής υπηρεσίας από την ZeniΘ για παροχή της υπηρεσίας,
                προκειμένου να δύναται η ZeniΘ να παράσχει την υπηρεσία ΕΚΔΟΣΗΣ ΠΙΣΤΟΠΟΙΗΤΙΚΟΥ ΕΝΕΡΓΕΙΑΚΗΣ ΑΠΟΔΟΣΗΣ (Π.Ε.Α.), εφόσον ο ίδιος το
                επιλέξετε.
            </p>
            <b>Αποδέκτες</b>
            <ul style={{listStyleType: "none"}}>
                <li>Α. Εξουσιοδοτημένο προσωπικό της ZeniΘ</li>
                <li>Β. Εξωτερικοί Συνεργάτες της ZeniΘ για την παροχή υπηρεσιών ΕΚΔΟΣΗΣ ΠΙΣΤΟΠΟΙΗΤΙΚΟΥ ΕΝΕΡΓΕΙΑΚΗΣ ΑΠΟΔΟΣΗΣ (Π.Ε.Α.).</li>
                <li>Γ. Εξωτερικοί Συνεργάτες της ZeniΘ για την παροχή υπηρεσιών εξυπηρέτησης μέσω τηλεφωνικού κέντρου.</li>
                <li>Δ. Οποιαδήπoτε αρμόδια εποπτική, δημόσια ή δικαστική αρχή, εφόσον αυτό επιβάλλεται από το εκάστοτε ισχύον νομοθετικό πλαίσιο ή από
                    δικαστική απόφαση.
                </li>                
            </ul>
            <p>
                <b>Τα Δικαιώματά σας:</b> Ως υποκείμενο δεδομένων προσωπικού χαρακτήρα, έχετε ορισμένα δικαιώματα. Συγκεκριμένα, μπορείτε α) να έχετε
                ενημέρωση και να λαμβάνετε αντίγραφο των δεδομένων σας κατόπιν αιτήματος, β) να απαιτήσετε από την ZeniΘ να διορθώσει λανθασμένα
                ή ελλιπή δεδομένα, γ) να διαγράψει ή να σταματήσει την επεξεργασία των δεδομένων σας, για παράδειγμα όταν τα δεδομένα δεν είναι πλέον
                απαραίτητα για τους σκοπούς της επεξεργασίας, δ) να αντιταχθείτε στην επεξεργασία των δεδομένων σας, όπου η ZeniΘ βασίζεται σε έννομα
                συμφέροντά της ως νομικό υπόβαθρο για την επεξεργασία, ε) να ζητήσετε από την ΖeniΘ την φορητότητα των δεδομένων προσωπικού
                χαρακτήρα σας στ) να ανακαλέσετε τη συγκατάθεσή σας για την επεξεργασία ανά πάσα στιγμή και χωρίς κάποια οικονομική επιβάρυνση. [Το
                δικαίωμα αυτό υφίσταται μόνο εάν η συναίνεση χρησιμοποιείται ως προϋπόθεση της επεξεργασίας].
            </p>
            <p>
                Σε περίπτωση άσκησης ενός εκ των ανωτέρω αναφερόμενων δικαιωμάτων σας, η ZeniΘ, θα λάβει κάθε δυνατό μέτρο για την ικανοποίηση του
                αιτήματος σας εντός ενός (1) μηνός από την λήψη αυτού, ενημερώνοντας σας γραπτώς για την ικανοποίηση του αιτήματος σας ή τους λόγους 
                που εμποδίζουν την εκ μέρους σας άσκηση, ή και την ικανοποίηση ενός ή και περισσότερων εκ των ως άνω αναφερόμενων δικαιωμάτων σας
                σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων.
            </p>
            <p>
                <b>Διακράτηση:</b>Τα δεδομένα σας που αφορούν στην έκδοση κωδικού ενεργειακής υπηρεσίας ZeniΘ, καθώς και την παροχή της υπηρεσίας
                ΕΚΔΟΣΗΣ ΠΙΣΤΟΠΟΙΗΤΙΚΟΥ ΕΝΕΡΓΕΙΑΚΗΣ ΑΠΟΔΟΣΗΣ (Π.Ε.Α.), θα τηρούνται από την ZeniΘ για το χρόνο που παραμένει σε ισχύ η σύμβαση
                προμήθειας φυσικού αερίου ή ηλεκτρικού ρεύματος, που έχετε συνάψει με την ZeniΘ, εκτός αν ανακαλέσετε τη συγκατάθεσή σας για την 
                επεξεργασία μόνον των συγκεκριμένων δεδομένων που συνδέονται με τις ανωτέρω υπηρεσίες και υπό την επιφύλαξη ότι δεν θίγονται τα
                νόμιμα δικαιώματα και οι υποχρεώσεις της ZeniΘ για τη διακράτηση των δεδομένων αυτών από την ZeniΘ σύμφωνα με τα οριζόμενα στις
                διατάξεις του Κανονισμού και της εκάστοτε ισχύουσας κείμενης νομοθεσίας.
            </p>
            <p>
                Περαιτέρω, σας γνωρίζουμε ότι έχετε το δικαίωμα να προσφύγετε στην Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα για ζητήματα
                που αφορούν την επεξεργασία προσωπικών σας δεδομένων. Για την αρμοδιότητα της Αρχής και τον τρόπο υποβολής καταγγελίας, μπορείτε
                να επισκεφθείτε την ιστοσελίδα της (www.dpa.gr → Τα δικαιώματά μου →Υποβολή καταγγελίας), όπου υπάρχουν αναλυτικές πληροφορίες.
            </p>
            <p>
                <b>Υπεύθυνος Προστασίας Δεδομένων:</b> Για την άσκηση των δικαιωμάτων σας, μπορείτε να απευθυνθείτε στον Υπεύθυνο Προστασίας Δεδομένων
                (DPO) της ZeniΘ, στο τηλέφωνο: 2311-223 000, καθώς και στο email: <a href={"mailto:dataprivacy@zenith.gr"}>dataprivacy@zenith.gr</a>
            </p>
            <p>
                Για περισσότερες πληροφορίες, παρακαλούμε διαβάστε την Πολιτική Απορρήτου της ΖeniΘ στον σύνδεσμο <a href={"https://www.zenith.gr/privacy/"}>https://www.zenith.gr/privacy/</a>
            </p>
            <p>
                <b>
                    Συναινώ για την επεξεργασία των προσωπικών μου δεδομένων από την ZeniΘ για την έκδοση κωδικού ενεργειακής υπηρεσίας ZeniΘ,
                    καθώς και την παροχή της υπηρεσίας ΕΚΔΟΣΗΣ ΠΙΣΤΟΠΟΙΗΤΙΚΟΥ ΕΝΕΡΓΕΙΑΚΗΣ ΑΠΟΔΟΣΗΣ (Π.Ε.Α.).
                </b>
            </p>
            <p>
                Στην περίπτωση μη συγκατάθεσής σας, σας ενημερώνουμε ότι η συγκεκριμένη υπηρεσία δεν είναι εφικτό να παρασχεθεί.
            </p>
            <p>
                Σας ενημερώνουμε ότι μπορείτε να ανακαλέστε την συγκατάθεσή σας οποτεδήποτε και χωρίς κόστος αποστέλλοντας email στην διεύθυνση <a href={"mailto:dataprivacy@zenith.gr"}>dataprivacy@zenith.gr</a>
            </p>
        </React.Fragment>
    )
}

function YdeServiceLegal(){
    return(
        <React.Fragment>
            <h6>Ειδοποίηση Ιδιωτικότητας - Υπηρεσίας Χορήγησης Ηλεκτρολογικού Σχεδίου(Υ.Δ.Ε.)</h6>
            <p>
                Τα προσωπικά σας δεδομένα, που μας παρέχετε με την υποβολή αιτήματος για την παροχή της ενεργειακής υπηρεσίας ΧΟΡΗΓΗΣΗΣ
                ΗΛΕΚΤΡΟΛΟΓΙΚΟΥ ΣΧΕΔΙΟΥ (Υ.Δ.Ε.), συλλέγονται και επεξεργάζονται από την Εταιρεία Προμήθειας Αερίου Θεσσαλονίκης - Θεσσαλίας Α.Ε.
                (ΖeniΘ) που εδρεύει στη Θεσσαλονίκη, οδός 26ης Οκτωβρίου, με Α.Φ.Μ. 997998048, ΓΕΜΗ 141002104000 τηλ. επικοινωνίας 2311223099, που
                εκπροσωπείται νόμιμα, σύμφωνα με τον Γενικό Κανονισμό (ΕΕ) 2016/679 περί προστασίας δεδομένων προσωπικού χαρακτήρα.
            </p>
            <p>
                <b>Σκοπός της Επεξεργασίας:</b> Η ΖeniΘ (Υπεύθυνος Επεξεργασίας), επεξεργάζεται τα προσωπικά δεδομένα σας: ονοματεπώνυμο, διεύθυνση,
                αριθμό σταθερού τηλεφώνου ή αριθμό κινητού τηλέφωνο, ΑΦΜ, Δ.Ο.Υ, τη διεύθυνση ηλεκτρονικού ταχυδρομείου (email) καθώς και
                οποιοδήποτε τεχνικό ή κτιριακό ή περιουσιακό δεδομένο είναι απαραίτητο για την παροχή της ενεργειακής υπηρεσίας ΧΟΡΗΓΗΣΗΣ
                ΗΛΕΚΤΡΟΛΟΓΙΚΟΥ ΣΧΕΔΙΟΥ (Υ.Δ.Ε.), για τους ακόλουθους σκοπούς: α) παροχής της ενεργειακής υπηρεσίας ΧΟΡΗΓΗΣΗΣ ΗΛΕΚΤΡΟΛΟΓΙΚΟΥ
                ΣΧΕΔΙΟΥ (Υ.Δ.Ε.), β) εκδόσεως κωδικού ενεργειακής υπηρεσίας από την ZeniΘ για παροχή της υπηρεσίας, προκειμένου να δύναται η ZeniΘ να
                παράσχει την υπηρεσία ΧΟΡΗΓΗΣΗΣ ΗΛΕΚΤΡΟΛΟΓΙΚΟΥ ΣΧΕΔΙΟΥ (Υ.Δ.Ε.), εφόσον ο ίδιος το επιλέξετε.
            </p>
            <b>Αποδέκτες</b>
            <ul style={{listStyleType : "none"}}>
                <li>Α. Εξουσιοδοτημένο προσωπικό της ZeniΘ</li>
                <li>Β. Εξωτερικοί Συνεργάτες της ZeniΘ για την παροχή υπηρεσιών ΧΟΡΗΓΗΣΗΣ ΗΛΕΚΤΡΟΛΟΓΙΚΟΥ ΣΧΕΔΙΟΥ (Υ.Δ.Ε.).</li>
                <li>Γ. Εξωτερικοί Συνεργάτες της ZeniΘ για την παροχή υπηρεσιών εξυπηρέτησης μέσω τηλεφωνικού κέντρου.</li>
                <li>Δ. Οποιαδήπoτε αρμόδια εποπτική, δημόσια ή δικαστική αρχή, εφόσον αυτό επιβάλλεται από το εκάστοτε ισχύον νομοθετικό πλαίσιο ή από
                    δικαστική απόφαση.
                </li>                
            </ul>
            <p>
                <b>Τα Δικαιώματά σας:</b> Ως υποκείμενο δεδομένων προσωπικού χαρακτήρα, έχετε ορισμένα δικαιώματα. Συγκεκριμένα, μπορείτε α) να έχετε
                ενημέρωση και να λαμβάνετε αντίγραφο των δεδομένων σας κατόπιν αιτήματος, β) να απαιτήσετε από την ZeniΘ να διορθώσει λανθασμένα
                ή ελλιπή δεδομένα, γ) να διαγράψει ή να σταματήσει την επεξεργασία των δεδομένων σας, για παράδειγμα όταν τα δεδομένα δεν είναι πλέον
                απαραίτητα για τους σκοπούς της επεξεργασίας, δ) να αντιταχθείτε στην επεξεργασία των δεδομένων σας, όπου η ZeniΘ βασίζεται σε έννομα
                συμφέροντά της ως νομικό υπόβαθρο για την επεξεργασία, ε) να ζητήσετε από την ΖeniΘ την φορητότητα των δεδομένων προσωπικού
                χαρακτήρα σας στ) να ανακαλέσετε τη συγκατάθεσή σας για την επεξεργασία ανά πάσα στιγμή και χωρίς κάποια οικονομική επιβάρυνση. [Το
                δικαίωμα αυτό υφίσταται μόνο εάν η συναίνεση χρησιμοποιείται ως προϋπόθεση της επεξεργασίας].
            </p>
            <p>
                Σε περίπτωση άσκησης ενός εκ των ανωτέρω αναφερόμενων δικαιωμάτων σας, η ZeniΘ, θα λάβει κάθε δυνατό μέτρο για την ικανοποίηση του
                αιτήματος σας εντός ενός (1) μηνός από την λήψη αυτού, ενημερώνοντας σας γραπτώς για την ικανοποίηση του αιτήματος σας ή τους λόγους
                που εμποδίζουν την εκ μέρους σας άσκηση, ή και την ικανοποίηση ενός ή και περισσότερων εκ των ως άνω αναφερόμενων δικαιωμάτων σας
                σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων.
            </p>
            <p>
                <b>Διακράτηση:</b> Τα δεδομένα σας που αφορούν στην έκδοση κωδικού ενεργειακής υπηρεσίας ZeniΘ, καθώς και την παροχή της υπηρεσίας
                ΧΟΡΗΓΗΣΗΣ ΗΛΕΚΤΡΟΛΟΓΙΚΟΥ ΣΧΕΔΙΟΥ (Υ.Δ.Ε.), θα τηρούνται από την ZeniΘ για το χρόνο που παραμένει σε ισχύ η σύμβαση προμήθειας
                φυσικού αερίου ή ηλεκτρικού ρεύματος, που έχετε συνάψει με την ZeniΘ, εκτός αν ανακαλέσετε τη συγκατάθεσή σας για την επεξεργασία
                μόνον των συγκεκριμένων δεδομένων που συνδέονται με τις ανωτέρω υπηρεσίες και υπό την επιφύλαξη ότι δεν θίγονται τα νόμιμα δικαιώματα
                και οι υποχρεώσεις της ZeniΘ για τη διακράτηση των δεδομένων αυτών από την ZeniΘ σύμφωνα με τα οριζόμενα στις διατάξεις του
                Κανονισμού και της εκάστοτε ισχύουσας κείμενης νομοθεσίας.
            </p>
            <p>
                Περαιτέρω, σας γνωρίζουμε ότι έχετε το δικαίωμα να προσφύγετε στην Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα για ζητήματα 
                που αφορούν την επεξεργασία προσωπικών σας δεδομένων. Για την αρμοδιότητα της Αρχής και τον τρόπο υποβολής καταγγελίας, μπορείτε
                να επισκεφθείτε την ιστοσελίδα της (www.dpa.gr → Τα δικαιώματά μου →Υποβολή καταγγελίας), όπου υπάρχουν αναλυτικές πληροφορίες.
            </p>
            <p>
                <b>Υπεύθυνος Προστασίας Δεδομένων:</b> Για την άσκηση των δικαιωμάτων σας, μπορείτε να απευθυνθείτε στον Υπεύθυνο Προστασίας Δεδομένων
                (DPO) της ZeniΘ, στο τηλέφωνο: 2311-223 000, καθώς και στο email: <a href={"mailto:dataprivacy@zenith.gr"}>dataprivacy@zenith.gr</a>
            </p>
            <p>Για περισσότερες πληροφορίες, παρακαλούμε διαβάστε την Πολιτική Απορρήτου της ΖeniΘ στον σύνδεσμο <a href={"https://www.zenith.gr/privacy/"}>https://www.zenith.gr/privacy/</a></p>
            <p>
                <b>Συναινώ για την επεξεργασία των προσωπικών μου δεδομένων από την ZeniΘ για την έκδοση κωδικού ενεργειακής υπηρεσίας ZeniΘ,
                    καθώς και την παροχή της υπηρεσίας ΧΟΡΗΓΗΣΗΣ ΗΛΕΚΤΡΟΛΟΓΙΚΟΥ ΣΧΕΔΙΟΥ (Υ.Δ.Ε.).</b>
            </p>
            <p>Στην περίπτωση μη συγκατάθεσής σας, σας ενημερώνουμε ότι η συγκεκριμένη υπηρεσία δεν είναι εφικτό να παρασχεθεί.</p>
            <p>
                Σας ενημερώνουμε ότι μπορείτε να ανακαλέστε την συγκατάθεσή σας οποτεδήποτε και χωρίς κόστος αποστέλλοντας email στην διεύθυνση <a href={"mailto:dataprivacy@zenith.gr"}>dataprivacy@zenith.gr</a>
            </p>
        </React.Fragment>
    )
}


function ServiceLegalContainer({pack}) {

    switch (pack) {
        case '001':
            return (<CheckupServiceLegal/>);
        case '002':
            return (<MaintenanceServiceLegal/>);
        case '003':
            return (<PeaServiceLegal/>);
        case '004': //yde
            return (<YdeServiceLegal />);
        case '011': // new yde (same as YDE)
            return (<YdeServiceLegal />);
        default:
            return null;
    }
}

export default ServiceLegalContainer;